import { useEffect } from 'react';

import type { Navigate } from 'src/types/navigate';

const useSetQueryParams = (
  validatedQueryParams: string,
  setQueryParams: Navigate
): void => {
  useEffect(() => {
    if (validatedQueryParams !== '') {
      // to avoid adding this query param change to the history
      // we need to pass { replace: true }
      // see the `note` part under https://reactrouter.com/docs/en/v6/api#usesearchparams
      setQueryParams(validatedQueryParams, { replace: true });
    }
  }, [setQueryParams, validatedQueryParams]);
};

export default useSetQueryParams;
